import { CommonCancellationsCrumbs } from './breadcrumb';

export const CancellationDueDeathSearchCrumbs = [
  ...CommonCancellationsCrumbs,
  {
    name: 'Ricerca Persona - Cancellazione per morte',
    path: '/cancellazioni/cancellazione-per-morte',
  },
];

export const CancellationDueDeathFormCrumbs = [
  ...CancellationDueDeathSearchCrumbs,
  {
    name: 'Cancellazione per morte',
    path: '/cancellazioni/cancellazione-per-morte/cancellazione',
  },
];
